"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

function isEmpty(value) {
  return value === null || value === undefined || Number.isNaN(value);
}

exports.isEmpty = isEmpty;

function toRaw(object) {
  return JSON.parse(JSON.stringify(object));
}

exports.toRaw = toRaw;

function cleanEmpty(object) {
  object = object;

  for (var key in object) {
    if (isEmpty(object[key])) {
      delete object[key];
    }
  }

  return object;
}

exports.cleanEmpty = cleanEmpty;

function sleep(ms) {
  return new Promise(function (resolve) {
    return setTimeout(resolve, ms);
  });
}

exports.sleep = sleep;